import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Box,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
} from '@material-ui/core';
import AuthorizeCheckbox from '../authorizeThird/AuthorizeCheckbox';
import LoadingButton from '../../../../../../common/LoadingButton';
import { bodyTicketProductGenerator } from '../../../../../../../helpers/tickets/TicketsHelper';
import { createTicketNoProduct } from '../../../../../../../redux/actions/TicketActions';
import { useAnotherProductStyles } from './styles';

const AnotherProduct = ({ ...props }) => {
  const { mobile, motiveId, product, type, profile } = props;
  const classes = useAnotherProductStyles({ mobile });
  const { ticketNoProductStatus } = useSelector((state) => state.ticketReducer);
  const dispatch = useDispatch();
  const [motiveClient, setMotiveClient] = useState('');
  const [checked, setChecked] = useState(false);

  const optionsRadio = [
    'No es el color o modelo que elegí',
    'No es lo que dice la publicación',
  ];

  const handleOptions = (event) => {
    setMotiveClient(event.target.value);
  };

  const sendData = () => {
    const body = {
      ...bodyTicketProductGenerator({
        profile,
        type,
        motiveId,
        product,
        motiveClient: motiveClient,
      }),
    };
    dispatch(createTicketNoProduct(body));
  };

  return (
    <Box className={classes.boxContainer}>
      <Typography className={classes.radioTitle}>Elige una opción:</Typography>
      <RadioGroup onChange={handleOptions} value={motiveClient}>
        {optionsRadio.map((optionRadio, index) => (
          <FormControlLabel
            key={index}
            value={optionRadio}
            label={optionRadio}
            control={<Radio color="primary" />}
            className={classes.radioButtonOptions}
            data-cy={`radio${optionRadio.split(' ').join('')}`}
          />
        ))}
      </RadioGroup>

      <AuthorizeCheckbox
        onCheck={() => setChecked(!checked)}
        idComplement="AnotherProduct"
        disabled={motiveClient === ''}
      />

      <LoadingButton
        name="AnotherProduct"
        text="Enviar"
        className={classes.buttonSend}
        variant="contained"
        color="primary"
        loading={ticketNoProductStatus === 'loading'}
        onClick={sendData}
        disabled={!checked || motiveClient === ''}
        data-cy="AnotherProduct"
      />
    </Box>
  );
};

AnotherProduct.propTypes = {
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  type: PropTypes.string,
  product: PropTypes.object,
  profile: PropTypes.object,
};

export default AnotherProduct;
